module.exports = __webpack_public_path__ + "static/media/MoreVertical.abbb42db.svg";